import { useTranslation } from 'react-i18next';
import LogoRental from '@/assets/images/logo-icon-rental.svg';
import LogoGoolge from '@/assets/images/google_logo.png';
import BgFooter from '@/assets/images/foot_informaion.webp';
import Facebook from '@/assets/images/facebook.png';
import X from '@/assets/images/x.png';
import Line from '@/assets/images/line.png';
import { Link, useLocation } from 'react-router-dom';
import { ekDomain, ROUTES, WORDPRESS_PATH } from '@/configs/constants';
import { isPathEk } from '@/utils/routes';
import { useEffect, useMemo, useRef } from 'react';
import { useStore } from '@/hooks/useStore';

import './styles.scss';
import ParallaxImage from '@/components/general/ParallaxImage';
import { URL_CONFIG } from '@/configs/environment';
import { observer } from 'mobx-react-lite';

export default observer(function Footer() {
    // hooks
    const { t } = useTranslation('translation');
    const { pathname } = useLocation();
    const hidePosRef = useRef<HTMLDivElement | null>(null);

    // const
    const isEk = isPathEk(pathname);
    const currentYear = (new Date()).getFullYear();

    // store
    const {
        uiStore: { setObservable },
        authStore: { tokenEk, tokenGas }
    } = useStore();

    // state

    // life cycle
    useEffect(() => {
        if (hidePosRef.current) {
            const updatePosition = () => {
                if (hidePosRef?.current) {
                    const top = hidePosRef?.current?.getBoundingClientRect().top + window.scrollY;
                    setObservable('hidePosTop', top);
                }
            };

            window.addEventListener('scroll', updatePosition);
            window.addEventListener('resize', updatePosition);

            updatePosition();

            return () => {
                window.removeEventListener('scroll', updatePosition);
                window.removeEventListener('resize', updatePosition);
            };
        }
    }, [hidePosRef.current]);

    // function
    const socials = useMemo((): { src: string, alt: string, href: string }[] => {
        // Get current page URL and title, encoded for sharing
        const url = encodeURIComponent(window.location.href);
        const title = encodeURIComponent(document.title);

        return [
            {
                src: Facebook,
                alt: 'Facebook',
                href: `https://www.facebook.com/sharer/sharer.php?u=${url}`
            },
            {
                src: X,
                alt: 'X',
                href: `https://twitter.com/intent/tweet?url=${url}&text=${title}`
            },
            {
                src: Line,
                alt: 'Line',
                href: `https://social-plugins.line.me/lineit/share?url=${url}`
            }
        ];
    }, []);

    return (
        <div className='footer-enduser w-full bg-black-3 text-white leading-[1]'>
            <div className='footer-infor-area relative overflow-hidden pt-[min(100px,10vw)] pb-[min(100px,10vw)]'>
                <div className='pala-img z-10'>
                    <picture>
                        <source srcSet={BgFooter} type='image/webp' />
                        <ParallaxImage src={BgFooter} alt='' className='object-cover w-full h-full object-center' />
                    </picture>
                </div>
                <div className='relative wrapper-inner grid point-900:grid-cols-[min(155px,25vw),auto] grid-cols-1 point-900:items-center place-items-center overflow-hidden text-white gap-[min(60px,5vw)] z-20'>
                    <div className='point-900:w-full w-[min(90px,23vw)]'>
                        <img className='w-full max-w-full' src={LogoGoolge} alt='logo google' />
                    </div>
                    <div className='text-white w-full'>
                        <h3 className='point-900:text-left text-center text-[min(24px,4.5vw)] font-semibold leading-[calc(34/24)]'>ベストBikeはGoogleから選ばれました</h3>
                        <p className='mt-[min(25px,5vw)] leading-[calc(30/14)]'>
                            弊社の「日本の魅力をバイクで伝える」というビジネス手法が「将来価値の高い事業」と評価をいただき、
                            <br />
                            米国Google本社から「極めてポテンシャルの高い企業」と認定されました。※
                            <br />
                            バイク業界での認定は希有な例であり、日本を代表するレンタルバイク企業として引き続き多くの感動をお伝えして参りたいと思います。
                        </p>
                        <ul className='att-list'>
                            <li className='relative pl-[1em] leading-[calc(30/14)]'>Googleは米Alphabet Inc.の子会社です</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div
                ref={hidePosRef}
                className='footer-social-area flex point-900:justify-end justify-center wrapper-container pt-[min(50px,10vw)] pb-[min(40px,8vw)]'
            >
                <dl className='flex point-900:gap-[min(80px,8vw)] gap-[min(20px,5vw)] point-900:flex-row flex-col items-center'>
                    <dt className='text-fs-mid20 leading-[1]'>SNS SHARE</dt>
                    <dd className='flex gap-[min(40px,4vw)] items-center'>
                        {socials?.map(({ src, alt, href }, i) => (
                            <a
                                key={i}
                                className='w-[min(42px,8vw)]'
                                href={href ?? ''}
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <img
                                    src={src}
                                    className='block w-full max-w-full'
                                    alt={alt}
                                />
                            </a>

                        ))}
                    </dd>
                </dl>
            </div>
            <div className='footer-nav-area wrapper-container relative grid point-900:grid-cols-[min(330px,38%),auto] grid-cols-1 items-end gap-[min(20px,5vw)] pt-[min(40px,8vw)] pb-[min(50px,10vw)]'>
                <div className='w-full footer-nav_about point-900:block flex flex-col items-center'>
                    <div className='point-900:w-full w-[min(290px,70vw)]'>
                        <div
                            // onClick={() => {
                            //     window.location.href = (`${URL_CONFIG.DOMAIN_WORDPRESS.url}/${isEk ? ekDomain : ''}`);
                            // }}
                            className='w-full grid [grid-template-columns:26%_auto] items-center [gap:3%] [aspect-ratio:1/0.2414]'
                        >
                            <span className='icon'><img src={LogoRental} alt='' /></span>
                            <svg className='fill-white w-full max-w-full' viewBox='0 0 158.286 28.754' aria-label='ベストBikeレンタル' role='img'>
                                <use href={isEk ? '#kick-logo' : '#main-logo'}></use>
                            </svg>
                        </div>
                    </div>

                    <div className='mt-[min(30px,6vw)] point-900:text-left text-center'>
                        <p className='leading-[calc(30/14)]'>
                            株式会社ベストBike
                            <br />
                            〒220-0004
                            <br />
                            神奈川県横浜市西区北幸1-11-5 相鉄KSビル9階
                            <br />
                            TEL :
                            <a href='tel:045-594-6105'> 045-594-6105</a>
                        </p>
                    </div>
                </div>
                <div className='w-full footer-nav_link grid grid-cols-[auto]'>
                    <div className='w-full grid grid-cols-1 point-900:justify-items-end justify-items-center gap-[min(20px,5vw)] relative box-border'>
                        {
                            ((isEk && !tokenEk) || (!isEk && !tokenGas)) && (
                                <>
                                    <div className='w-full max-w-[320px] round-button'>
                                        <Link to={isEk ? `/${ekDomain}${ROUTES.signup.href}` : ROUTES.signup.href} className='relative'>
                                            <span>新規会員登録</span>
                                        </Link>
                                    </div>
                                    <div className='w-full max-w-[320px] round-button'>
                                        <Link to={isEk ? `/${ekDomain}${ROUTES.signin.href}` : ROUTES.signin.href} className='relative'>
                                            <span>会員ログイン</span>
                                        </Link>
                                    </div>
                                </>
                            )
                        }

                    </div>
                    <ul className='foot-contents-nav flex point-900:justify-end justify-center flex-wrap mt-[min(40px,8vw)] gap-y-[min(15px,3vw)] gap-x-0 leading-[1]'>
                        <li>
                            <Link
                                to={`${URL_CONFIG.DOMAIN_WORDPRESS.url}/${WORDPRESS_PATH.about[isEk ? 'hrefEk' : 'href']}`}
                                className='point-900:text-[min(3.6vw,14px)] text-[min(12px,3.2vw)] hover:text-primaryWeb'
                            >
                                {t('words_title.company_introduction')}
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`${URL_CONFIG.DOMAIN_WORDPRESS.url}/${WORDPRESS_PATH.privacypolicy[isEk ? 'hrefEk' : 'href']}`}
                                className='point-900:text-[min(3.6vw,14px)] text-[min(12px,3.2vw)] hover:text-primaryWeb'
                            >
                                {t('words_title.privacy_policy')}
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`${URL_CONFIG.DOMAIN_WORDPRESS.url}/${WORDPRESS_PATH.terms[isEk ? 'hrefEk' : 'href']}`}
                                className='point-900:text-[min(3.6vw,14px)] text-[min(12px,3.2vw)] hover:text-primaryWeb'
                            >
                                {t('words_title.terms_and_conditions')}
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`${URL_CONFIG.DOMAIN_WORDPRESS.url}/${WORDPRESS_PATH.aboutTokusho[isEk ? 'hrefEk' : 'href']}`}
                                className='point-900:text-[min(3.6vw,14px)] text-[min(12px,3.2vw)] hover:text-primaryWeb'
                            >
                                {t('words_title.act_of_specified')}
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`${URL_CONFIG.DOMAIN_WORDPRESS.url}/${WORDPRESS_PATH.contact[isEk ? 'hrefEk' : 'href']}`}
                                className='point-900:text-[min(3.6vw,14px)] text-[min(12px,3.2vw)] hover:text-primaryWeb'
                            >
                                {t('words_title.contact_us')}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <p className='bg-black-4 p-5 text-[0.875em] text-center leading-[1]'>
                {`© 2018${currentYear ? ` - ${currentYear}` : ''} レンタルバイクのベストBike`}
            </p>
        </div>
    );
});
